import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { DrillSmartHomeWorkRow } from "components/molecules/DrillSmartHomeWorkRow";
import { Button, Typography } from "components/atoms";
import { BackIcon } from "components/atoms/Icon";
import { CONTENT_OBJECT_TYPE_ID, MOBILE_WIDTH } from "utils/constants";
import { useScreenSize } from "hooks";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const DrillSmartMobile = ({ theme }: IProps) => {
  const data: any = [
    {
      Name: "Keep Pluggin Away (Easy 1)",
      Status: "Not Started",
      ContentObjectTypeId: 12,
      DateCompleted: "9999-12-31T23:59:59.9999999",
      DeliveryTypes: "None",
      Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
      Id: 1982,
      InstanceGuid: "00000000-0000-0000-0000-000000000000",
      IsLocked: false,
      LaunchUrl:
        "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
      Url: "",
    },
    {
      Name: "Keep Pluggin Away (Medium 1)",
      Status: "In Progress",
      ContentObjectTypeId: 12,
      DateCompleted: "9999-12-31T23:59:59.9999999",
      DeliveryTypes: "None",
      Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
      Id: 1982,
      InstanceGuid: "00000000-0000-0000-0000-000000000000",
      IsLocked: false,
      LaunchUrl:
        "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
      Url: "",
    },
    {
      Name: "Keep Pluggin Away (Medium 2)",
      Status: "In Progress",
      ContentObjectTypeId: 12,
      DateCompleted: "9999-12-31T23:59:59.9999999",
      DeliveryTypes: "None",
      Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
      Id: 1982,
      InstanceGuid: "00000000-0000-0000-0000-000000000000",
      IsLocked: false,
      LaunchUrl:
        "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
      Url: "",
    },
    {
      Name: "Keep Pluggin Away (Hard 1)",
      Status: "Completed",
      ContentObjectTypeId: 12,
      DateCompleted: "9999-12-31T23:59:59.9999999",
      DeliveryTypes: "None",
      Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
      Id: 1982,
      InstanceGuid: "00000000-0000-0000-0000-000000000000",
      IsLocked: false,
      LaunchUrl:
        "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
      Url: "",
    },
  ];

  const navigate = useNavigate();

  const screen = useScreenSize();

  const handleBack = () => {
    navigate("/self-paced");
  };

  useEffect(() => {
    if (screen.width > MOBILE_WIDTH) {
      navigate("/self-paced");
    }
  }, [screen, navigate]);

  return (
    <div className="drill-smart-mobile-wrapper">
      <div className="back-section">
        <BackIcon
          color={theme === "light" ? "#273E5A" : "#329EE2"}
          onClickHandle={handleBack}
        />
        <Typography label="Back" variant="h6Medium" onClick={handleBack} />
      </div>
      <div className="drill-smart-mobile-intro-section">
        <div className="titles-wrapper">
          <div className="main-title-wrapper">
            <Typography label={`Drill`} variant="h1Med" />
            <Typography
              label={`Smart`}
              variant="h1Bold"
              styles="smart-text-style"
            />
          </div>
          <Typography
            label={`Your best way to practice!`}
            variant="h9Medium"
            styles="subtext-style"
          />
        </div>
        <Typography
          label={`First, you’ll take a calibration drill and based on your results you’ll get a follow-up drill that’s at the right level for you... just like on GRE!`}
          variant="h7Med"
        />
        <Button
          icon={false}
          label="Start DrillSmart"
          type="score"
          onClick={() => {}}
          isLoading={false}
        />
      </div>
      <div className="drill-smart-mobile-choose-drill-section">
        <Typography label={`Choose a Drill`} variant="h1Med" />
        <Typography
          label={`Here’s the full list of drills available in this topic area. Do as many as you’d like, at any difficulty level.`}
          variant="h7Med"
          styles="choose-drill-infotext-style"
        />
        <div className="drill-contentobject-wrapper">
          {data.map((value: any, index: number) => (
            <DrillSmartHomeWorkRow
              index={index}
              textIconLabel={value.Name}
              iconType={
                value.Status === "Lock" || value.IsLocked === true
                  ? "lock"
                  : value.Status === "Not Started"
                    ? "empty-circle"
                    : value.Status === "Completed"
                      ? "select"
                      : "yellow-timer"
              }
              middleLabel={
                value.Status === "Completed"
                  ? `Completed on ${formatToLocalDate(value.DateCompleted, "MM/DD/YYYY")}`
                  : value.Status === "Not Started"
                    ? "Not Started"
                    : value.Status === "Lock"
                      ? "Locked"
                      : "In Progress"
              }
              handlePrimaryBtnClick={() => {}}
              handleSecondaryBtnClick={() => {}}
              status={value.Status}
              isLocked={value.IsLocked}
              contentObjectType={Object.keys(CONTENT_OBJECT_TYPE_ID).find(
                (key: string) =>
                  CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
              )}
              theme={theme}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
